module.exports = __webpack_public_path__ + "img/retrofit-4.0e5d942c.jpg";